<header class="modal-header d-flex justify-content-between align-items-center">
  <div class="side" *ngIf="back">
    <a class="back" mat-icon-button (click)="onBack($event)">
      <i class="far fa-long-arrow-left ts-150 text-base opacity-50"></i>
    </a>
  </div>
  <h2 class="ts-150 m-0 text-center w-100"><ng-content></ng-content></h2>
  <div class="side" *ngIf="back"></div>
</header>
